import Nav from "@/components/Nav";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import Stats from "@/components/sections/Stats";
import About from "@/components/sections/About";
import Showreel from "@/components/sections/Showreel";
import Thumbnails from "@/components/sections/Thumbnails";
import Services from "@/components/sections/Services";
import Process from "@/components/sections/Process";
import Testimonials from "@/components/sections/Testimonials";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import useReveal from "@/hooks/useReveal";

export default function Landing() {
  useReveal();
  return (
    <main data-testid="landing-page" className="relative bg-[#000000] text-[#F4F4F5] overflow-x-hidden">
      <Nav />
      <Hero />
      <Marquee />
      <Stats />
      <About />
      <Showreel />
      <Thumbnails />
      <Services />
      <Process />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
